import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";
import { applyPreferences, LiveProvider, registerErrorTexts, settleSkippedViewTransitions } from "@nexxt/app-kit";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { queryClient } from "./api";
import { errorTexts } from "./errors";
import { router } from "./router";

registerErrorTexts(errorTexts);
settleSkippedViewTransitions();
applyPreferences();
matchMedia("(prefers-color-scheme: dark)").addEventListener("change", applyPreferences);

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LiveProvider>
        <RouterProvider router={router} />
      </LiveProvider>
    </QueryClientProvider>
  </StrictMode>,
);
